import { FormlyFieldConfig } from '@ngx-formly/core';
import { BaseNode } from './BaseNode';
import { Injector } from '@angular/core';
import { FormlyView } from '../Data/FormlyView';
import { ListDataColumn } from '../Data/ListColumn';
import { DateUtil } from '../DateUtil';
import { FormlyUtil } from '../FormlyUtil';

export class QueryConditionsNode extends BaseNode {
  originalInfo: any;
  constructor(injector: Injector, queryConditions: FormlyFieldConfig[]) {

    const model: any = {};
    queryConditions.forEach((f: any) => {
      if (f.props?.['defaultValue'] != null) {
        model[String(f.key)] = f.props['defaultValue'];
      }
    });
    const cloned = FormlyUtil.cloneFormlyView(queryConditions, model);
    super(
      injector,
      new FormlyView(cloned.form, cloned.fields, cloned.model),
      'Conditions',
    );
    this.originalInfo = cloned;
  }
  getCriteria(): string {
    let result: string[] = [];

    const arrayModel = Object.entries(this.data.model).map(([key, value]) => {
      return { key, value };
    });

    arrayModel.forEach((modelItem: any) => {
      const foundField = this.data.fields.find(
        (fieldItem: any) => fieldItem.key == modelItem.key,
      );
      if (modelItem.value !== null && modelItem.value !== '') {
        switch (foundField.props['conditionTypeValue']) {
          case ListDataColumn.DATE:
            result.push(
              `${foundField.key}:${foundField.props['conditionType']}:${DateUtil.getParseToNumber(modelItem.value)}~`,
            );
            break;
          default:
            result.push(
              `${foundField.key}:${foundField.props['conditionType']}:${modelItem.value}~`,
            );
        }
      }
    });

    return result.join('');
  }

  getListItem(): any[] {
    return [this.label];
  }

  override cloneNode(newParent: BaseNode): BaseNode {
    const clonedNode = new QueryConditionsNode(this.ioc!, this.originalInfo.fields);
    clonedNode.parent = newParent;
    return clonedNode; 
  }
  
}
